import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { BookMarkOption } from "../../_objects/inspection-image";

@Injectable({
  providedIn: "root"
})
export class VideoBookmarksStateService {
  private bookmarkAdded$ = new Subject<BookMarkOption>();
  private inspectionBookmarks$ = new BehaviorSubject<BookMarkOption[]>([]);
  public bookmarkAdded = this.bookmarkAdded$.asObservable();
  public inspectionBookmarks = this.inspectionBookmarks$.asObservable();

  public addBookmark(bookmark: BookMarkOption) {
    this.bookmarkAdded$.next(bookmark);
  }

  public updateInspectionBookmarks(bookmarks: BookMarkOption[]) {
    this.inspectionBookmarks$.next(bookmarks);
  }
}
